import { baseFetchSimple } from "../api/baseFetchSimple";
import { pacvueApiBaseURL } from "../credentials/consts/links";
export var ApiPacvueToken;
(function (ApiPacvueToken) {
    /**
     * swagger: https://apiusertest.pacvue.com/swagger/index.html
     *
     * @example
     *
     * curl -X GET "https://apiusertest.pacvue.com/api/Helium10/refreshToken?refreshToken=..."
     * const correctResponse = {
     *   code: 200,
     *   data: {
     *     accessToken: "...",
     *     identityToken: null,
     *     tokenType: "Bearer",
     *     refreshToken: "...",
     *     errorDescription: null,
     *     expiresIn: 86400,
     *     raw: '{"access_token":"...","expires_in":86400,"token_type":"Bearer","refresh_token":"..."}',
     *     json: {
     *       access_token: "...",
     *       expires_in: 86400,
     *       token_type: "Bearer",
     *       refresh_token: "...",
     *     },
     *     exception: null,
     *     isError: false,
     *     errorType: 0,
     *     httpStatusCode: 200,
     *     httpErrorReason: null,
     *     error: null,
     *   },
     * };
     *
     * const errorResponse = {
     *   code: 200,
     *   data: {
     *     accessToken: null,
     *     identityToken: null,
     *     tokenType: null,
     *     refreshToken: null,
     *     errorDescription: null,
     *     expiresIn: 0,
     *     raw: '{"error":"invalid_grant"}',
     *     json: {
     *       error: "invalid_grant",
     *     },
     *     exception: null,
     *     isError: true,
     *     errorType: 1,
     *     httpStatusCode: 400,
     *     httpErrorReason: null,
     *     error: "invalid_grant",
     *   },
     * };
     */
    ApiPacvueToken.refreshToken = async (refreshToken) => {
        return baseFetchSimple({
            method: "GET",
            url: `${pacvueApiBaseURL}/api/Helium10/refreshToken`,
            params: {
                refreshToken,
            },
        }).then((res) => res.data);
    };
})(ApiPacvueToken || (ApiPacvueToken = {}));
